const experiences = [
    {title: 'North Shore Animal Hospital',
    description: 'Veterinary Technician',
    features: [
        'Assisted veterinarians in performing medical procedures, including administering medications, taking X-rays, and conducting laboratory tests',
        'Aided in restraining animals during examinations or treatments to ensure the safety of both the animal and veterinary staff',
        'Administered vaccinations according to veterinarian instructions, maintaining accurate records of immunizations given',
        'Provided compassionate care to animals, including feeding, grooming, and monitoring their well-being during their stay at the hospital',
        'Communicated with pet owners to provide updates on their pets’ conditions and offer guidance on post-treatment care',
        'Drew blood samples from animals for diagnostic testing, ensuring proper handling and labeling of specimens',
        'Maintained a clean and organized work environment, including sterilizing equipment and ensuring proper disposal of medical waste'
    ],
    picture: 'nsah_cover.jpg',
    dates: '2025-2026',
    }, 
    {title: 'RIA in a Box',
    description: 'Software Developer',
    features: [
        'Used Windows/Apache/MySQL/PHP to develop features for an SAAS investment advisor company',
        'Collaborated with coworkers from various departments to meet client needs',
        'Designed schema/tables/UI as well as implementing new MVC architecture to implement new add on services for certain users',
        'Worked closely with product managers to deliver a UI experience clients would be happy with',
        'Refactored code to make efficient calls to the databases'
    ],
    picture: 'ria_cover.jpg',
    dates: '2021-2025',
    }, 
    {title: 'Meetopolis',
    description: 'Software Developer',
    features: [
        'Used React, Javascript, NodeJS, MySQL, and Express to build features on both the front and back end',
    ],
    picture: 'meetopolis_cover.jpg',
    dates: '2021-2021',
    }, 
    {title: 'Gemini Physical Therapy',
    description: 'Physical Therapist Aide',
    features: [
        'Oversaw patient’s exercise activity/progress.',
        'Collaborated with the head physical therapist to design custom workout plans for each patient.',
        'Assisted head physical therapist with treatment of patients along with general clerical duties.',
        'Communicated with insurance companies to get necessary information for specific patients.'
    ],
    picture: null,
    dates: '2017-2020',
    },
  ]

export default experiences;